import { Typography, Dialog, DialogContent, Stack, Button } from "@mui/material";

interface DomainIntregationCongratsProps {
  open: boolean;
  handleClose: () => void;
}

function DomainIntregationCongrats({ open, handleClose }: DomainIntregationCongratsProps) {
  return (
    <Dialog open={open} onClose={handleClose}
      PaperProps={{
        sx: {
          width: "1200px",
          maxWidth: "1200px",
          height: "auto",
          minHeight: "400px",
          overflow: "hidden"
        }
      }}>
      <DialogContent>
        <Stack alignItems="center">
          <img alt="Congratulations" src="/congratulations.jpg" />
          <Typography fontSize={34} align="center" sx={{ mt: 2 }}>
            Great!<br />Your Domain Integration Request Has Been Received!
          </Typography>
          <Typography fontSize={20} align="center" fontWeight={500} mt={2}>
            We are working on it, and will update you soon with additional information.
          </Typography>
          <Button color="secondary" variant="contained" onClick={handleClose} sx={{ mt: 2 }}>
            Close
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default DomainIntregationCongrats;
